import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.dashboard.sections.trafficPerDay.title',
    defaultMessage: 'Traffic per day',
    description: 'title of the traffic per day section on the dashboard',
  },
  fields: {
    from: {
      id: 'properties.from',
      defaultMessage: 'From',
      description: 'label of the from field',
    },
    to: {
      id: 'properties.until',
      defaultMessage: 'Until',
      description: 'label of the to field',
    },
  },
};

export default defineMessages(translations);
